import { zodResolver } from '@hookform/resolvers/zod'
import { LastKmsTransportEnum, MealsTypeEnum, TransportEnum } from '@repo/utils'
import React from 'react'
import { useForm, UseFormReturn } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'
import { z } from 'zod'

import CarbonFootprintDepartureCityField from './fields/CarbonFootprintDepartureCityField'
import CarbonFootprintEndOfJourneyField from './fields/CarbonFootprintEndOfJourneyField'
import CarbonFootprintMealTypeField from './fields/CarbonFootprintMealTypeField'
import CarbonFootprintTransportModeField from './fields/CarbonFootprintTransportModeField'
import { Button } from '../../../../shadcn/components/ui/button'
import { Form } from '../../../../shadcn/components/ui/form'
import Icon from '../../../atoms/icons/icon/Icon'

export type CarbonFootprintMealTypeFieldProps = {
  form: UseFormReturn<CarbonFootpringFormValues, any>
}

const createFormSchema = () => {
  return z.object({
    departureCity: z.object({
      description: z.string().min(1, 'La description est requise'),
      placeId: z.string().min(1, "L'ID du lieu est requis"),
      distance_meters: z.number().min(0, 'La distance doit être positive'),
    }),
    transportMode: z.nativeEnum(TransportEnum),
    endOfJourney: z.nativeEnum(LastKmsTransportEnum),
    mealType: z.nativeEnum(MealsTypeEnum),
  })
}

export type CarbonFootpringFormValues = z.infer<
  ReturnType<typeof createFormSchema>
>

const CarbonFootprintForm = ({
  defaultValues,
  onSubmit,
  houseLocation,
}: {
  defaultValues: Partial<CarbonFootpringFormValues>
  onSubmit: (data: CarbonFootpringFormValues) => void
  houseLocation?: google.maps.LatLngLiteral
}) => {
  const formSchema = createFormSchema()

  const form = useForm<CarbonFootpringFormValues>({
    resolver: zodResolver(formSchema),
    defaultValues,
  })

  return (
    <Form {...form}>
      <form
        id='carbon-footprint-form'
        className='flex flex-col gap-7'
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <div className='grid grid-cols-1 gap-4 md:grid-cols-2'>
          <CarbonFootprintDepartureCityField
            form={form}
            houseLocation={houseLocation}
          />
          <CarbonFootprintTransportModeField form={form} />
          <CarbonFootprintEndOfJourneyField form={form} />
          <CarbonFootprintMealTypeField form={form} />
        </div>
        <Button
          type='submit'
          className='hidden items-center gap-1 border-0 bg-green-800 md:flex'
        >
          <Icon name='leaf' size={16} className='text-green-500' />
          <span className='text-white'>
            <FormattedMessage
              id='ui.CarbonFootprintForm.buttonLabel'
              defaultMessage='Calculer mon empreinte'
            />
          </span>
        </Button>
      </form>
    </Form>
  )
}

export default CarbonFootprintForm
